import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import LeagueDialog from "src/components/leagues-admin/LeagueDialog";
import DeleteDialog from "../components/leagues-admin/DeleteDialog";
import { del, get, post, put } from "src/utils/networkUtils";
import { getUserPermissions } from "src/utils/permissionsUtils";

export default function CustomLeaguesPage() {
  const [rows, setRows] = useState(null);
  const [openLeagueDialog, setOpenLeagueDialog] = useState(false);
  const [showDeleteLeagueDialog, setShowDeleteLeagueDialog] = useState(false);
  const [editLeague, setEditLeague] = useState(null);
  const { isViewer } = getUserPermissions();
  const [deleteLeague, setDeleteLeague] = useState(null);
  useEffect(() => {
    get(`/leagues?limit=100&offset=0`).then(function (response) {
      setRows(response.leagues.filter((item) => item !== null));
    });
  }, []);

  const successLeagueHandler = (league) => {
    if (league?.league_id) {
      put(`/admin/league/${league.league_id}`, league).then(function (
        response
      ) {
        window.location.reload(false);
      });
    } else {
      post(`/admin/league`, league).then(function (response) {
        window.location.reload(false);
      });
    }
    setOpenLeagueDialog(false);
  };

  const deleteQuestionHandler = (id) => {
    del(`/admin/league/${id}`).then(function (response) {
      window.location.reload(false);
    });
  };
  const closeLeagueDialog = () => {
    setEditLeague(null);
    setOpenLeagueDialog(false);
  };
  const openAddLeagueDialog = () => {
    setEditLeague(null);
    setOpenLeagueDialog(true);
  };
  const openEditLeagueDialog = (index) => {
    const league = rows[index];
    setEditLeague(league);
    setOpenLeagueDialog(true);
  };

  const openDeleteLeagueDialog = (index) => {
    const league = rows[index];
    setDeleteLeague(league.league_id);
    setShowDeleteLeagueDialog(true);
  };
  return (
    <>
      <Helmet>
        <title>Featured Leagues</title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Featured Leagues
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => openAddLeagueDialog()}
          >
            New League
          </Button>
        </Stack>

        <Card>
          {rows === null ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Size</TableCell>
                      <TableCell>Sponsor slug</TableCell>
                      <TableCell>Vanity slug</TableCell>
                      <TableCell>Icon</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row?.league_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.type}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.size}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.sponsor_slug}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row?.vanity_slug}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <img
                            alt="league icon"
                            style={{ width: 100 }}
                            src={row?.icon}
                          />
                        </TableCell>
                        {!isViewer && (
                          <TableCell component="th" scope="row">
                            <Iconify
                              icon={"eva:edit-outline"}
                              sx={{ cursor: "pointer" }}
                              onClick={() => openEditLeagueDialog(index)}
                            />
                            <Iconify
                              icon={"eva:trash-2-outline"}
                              sx={{ cursor: "pointer" }}
                              onClick={() => openDeleteLeagueDialog(index)}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
      <LeagueDialog
        league={editLeague}
        open={openLeagueDialog}
        onSuccessHandler={successLeagueHandler}
        onClose={closeLeagueDialog}
      />
      <DeleteDialog
        openConfirm={showDeleteLeagueDialog}
        setOpenConfirm={setShowDeleteLeagueDialog}
        questionIndex={deleteLeague}
        deleteGameHandler={deleteQuestionHandler}
        title={"Are you sure you want to delete this league?"}
        description={"All cards with this league would be affected."}
      />
    </>
  );
}
